import type {FC} from 'react';

import {ContactFormSection} from '../../components/contact-form-section';

import type {SanityContactFormSectionFragment} from './contact-form-section';

type Props = {
	data: SanityContactFormSectionFragment;
	fullWidth?: boolean;
	insideToc?: boolean;
};

export const ContactFormSectionContainer: FC<Props> = ({data, fullWidth, insideToc}) => {
	return (
		<ContactFormSection
			options={{fullWidth, ...data.contentBlockOptions}}
			insideToc={insideToc}
		/>
	);
};
